function wallTimeParts(value, timezone) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return {
      year: Number(values.year),
      month: Number(values.month),
      day: Number(values.day),
      hour: Number(values.hour),
      minute: Number(values.minute),
    };
  } catch {
    return null;
  }
}

const pad = value => String(value).padStart(2, '0');

export function formatCompletionWallTime(value, timezone) {
  const parts = wallTimeParts(value, timezone);
  if (!parts) return '';
  return `${parts.year}-${pad(parts.month)}-${pad(parts.day)}T${pad(parts.hour)}:${pad(parts.minute)}`;
}

export function parseCompletionWallTime(value, timezone) {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(String(value || ''));
  if (!match) return null;
  const [, yearText, monthText, dayText, hourText, minuteText] = match;
  const desired = {
    year: Number(yearText),
    month: Number(monthText),
    day: Number(dayText),
    hour: Number(hourText),
    minute: Number(minuteText),
  };
  const desiredEpoch = Date.UTC(
    desired.year,
    desired.month - 1,
    desired.day,
    desired.hour,
    desired.minute,
  );
  const normalized = new Date(desiredEpoch);
  if (normalized.getUTCFullYear() !== desired.year
      || normalized.getUTCMonth() + 1 !== desired.month
      || normalized.getUTCDate() !== desired.day
      || normalized.getUTCHours() !== desired.hour
      || normalized.getUTCMinutes() !== desired.minute) {
    return null;
  }

  let instant = desiredEpoch;
  for (let attempt = 0; attempt < 4; attempt += 1) {
    const actual = wallTimeParts(new Date(instant), timezone);
    if (!actual) return null;
    const actualEpoch = Date.UTC(
      actual.year,
      actual.month - 1,
      actual.day,
      actual.hour,
      actual.minute,
    );
    const correction = desiredEpoch - actualEpoch;
    if (correction === 0) break;
    instant += correction;
  }

  const parsed = new Date(instant);
  return formatCompletionWallTime(parsed, timezone) === value ? parsed : null;
}
